var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagecircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.625 11.5C21.6284 12.8199 21.3201 14.1219 20.725 15.3C20.0194 16.7118 18.9348 17.8992 17.5924 18.7293C16.2501 19.5594 14.7032 19.9994 13.125 20C11.8051 20.0035 10.5031 19.6951 9.325 19.1L3.625 21L5.525 15.3C4.92993 14.1219 4.62156 12.8199 4.625 11.5C4.62561 9.92179 5.06561 8.37488 5.89572 7.03258C6.72583 5.69028 7.91325 4.6056 9.325 3.90003C10.5031 3.30496 11.8051 2.99659 13.125 3.00003H13.625C15.7093 3.11502 17.678 3.99479 19.1541 5.47089C20.6302 6.94699 21.51 8.91568 21.625 11V11.5Z",
    stroke: "#096DD9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagecircle);
export default __webpack_public_path__ + "static/media/Message circle.53fec7a1e4fc0904f8af3530ae795f64.svg";
export { ForwardRef as ReactComponent };